import { InjectionToken } from '@angular/core';

export const WEB_CONNECT_URL = new InjectionToken<string>('The URL for Connect via webRTC', {
  providedIn: 'root',
  factory: (): string => ''
});
